import { createTracker } from 'usage-tracker';
const getEventName = event => {
  switch (event) {
    case 'settingsInteraction':
      return 'Settings Interaction';
    case 'createStagedFormWithAI':
      return 'Create Staged Form With Ai';
    case 'createFormWithAI':
      return 'Create Form With AI';
    case 'saveStagedForm':
      return 'Save Staged Form';
    case 'enhancedPrompt':
      return 'Enhanced Prompt';
    case 'backButtonClicked':
      return 'Back Button Clicked';
    case 'updateStagedFormWithAI':
      return 'Update Staged Form With Ai';
    case 'saveStagedFormFailed':
      return 'Save Staged Form Failed';
    default:
      return event;
  }
};
export const UsageTracker = createTracker({
  standalone: true,
  lastKnownEventProperties: ['screen']
});
export const trackEvent = (eventName, properties) => {
  UsageTracker.track('Forms Ai Lib', getEventName(eventName), properties);
};